module.exports = __webpack_public_path__ + "img/banner.4ebeee96.jpg";